import type { IconProps } from '../types/IconProps.ts';
export const PieChart: IconProps = {
    name: 'PieChart',
    children: [
        `<path d="M22 13.1A10.8 10.8 0 0 0 10.9 2a.94.94 0 0 0-.9.96V13a1 1 0 0 0 1 1h10.04c.5 0 .94-.38.96-.9" />`,
        `<path d="M20 17.63A9.82 9.82 0 1 1 6.37 4" />`,
    ]
};